import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { IconArrowHead } from '../index';
import css from './GoBackButton.module.css';

/**
 * GoBackButton component that appears on pages without bottom navigation.
 * Only shows if the user navigated from within the marketplace (THQ).
 * Returns user to their previous in-app page.
 *
 * @param {boolean} desktopOnly - If true, only shows on desktop (>= 768px)
 */
const GoBackButton = ({ desktopOnly = false, onClick, showAlways = false, className = '' }) => {
  const history = useHistory();

  // Check if there's a previous page in the history stack
  // We check if the user came from within the app by looking at the history length
  // and checking if there's a referrer from the same origin
  const hasInternalReferrer = () => {
    if (typeof window == 'undefined') {
      return false;
    }
    // Check if history has more than 1 entry (meaning user navigated within the app)
    const hasHistory = window.history.length > 2;
    return hasHistory;
  };

  const checkHistoryPresent = hasInternalReferrer();

  const handleGoBack = () => {
    if (onClick) {
      onClick();
    } else if (checkHistoryPresent) {
      history.goBack();
    } else {
      history.push('/');
    }
  };

  const buttonClassName = `${css.goBackButton} ${desktopOnly ? css.desktopOnly : ''} ${className}`.trim();

  if (!checkHistoryPresent && !showAlways && !onClick) {
    return null;
  }

  return (
    <button
      type="button"
      className={buttonClassName}
      onClick={handleGoBack}
      aria-label="Go back to previous page"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="18"
        viewBox="0 0 11 18"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.792485 8.3323C0.402505 8.70251 0.402505 9.29749 0.792485 9.6677L8.79209 17.223C9.18407 17.5923 9.81603 17.5923 10.206 17.223C10.598 16.8538 10.598 16.256 10.206 15.8876L2.91438 9L10.206 2.11236C10.598 1.74309 10.598 1.14527 10.206 0.776951C9.81603 0.407683 9.18407 0.407683 8.79209 0.776951L0.792485 8.3323Z"
          fill="white"
          stroke="white"
        />
      </svg>
      {/* <IconArrowHead direction="left" size="small" rootClassName={css.arrowIcon} /> */}
      <span className={css.buttonText}>Go Back</span>
    </button>
  );
};

export default GoBackButton;
